import { toBase64, fromBase64 } from '@jsonjoy.com/base64';

export function encodeBase64(value: string) {
  return toBase64(new TextEncoder().encode(value));
}

export function decodeBase64(value: string) {
  return String.fromCharCode(...fromBase64(value));
}